module.exports = __webpack_public_path__ + "25ce7fc89de8ef4ea2270517ebe3b4f5.png";